const languages: { value: string; label: string }[] = [
  {
    value: 'en',
    label: 'English', // English
  },
  {
    value: 'ar',
    label: 'العربية', // Arabia
  },
  {
    value: 'zh',
    label: '中文（简体', // Chinese Simplified
  },
  {
    value: 'nl',
    label: 'Dutch', // Dutch
  },
  {
    value: 'fr',
    label: 'Français', // French
  },
  {
    value: 'de',
    label: 'Deutsch', // German
  },
  {
    value: 'hi',
    label: 'हिन्दी', // Hindi
  },
  {
    value: 'hu',
    label: 'Magyar', // Hungarian
  },
  {
    value: 'id',
    label: 'Bahasa Indonesia', // Indonesian (Bhasa)
  },
  {
    value: 'it',
    label: 'Italiano', // Italiano
  },
  {
    value: 'kn',
    label: 'ಕನ್ನಡ', //Kannada
  },
  {
    value: 'ko',
    label: '한국어', // Korean
  },
  {
    value: 'nb',
    label: 'Norsk', // Norwegian
  },
  {
    value: 'pl',
    label: 'Polski', // Polish
  },
  {
    value: 'pt',
    label: 'Português', // Portugues
  },
  {
    value: 'ro',
    label: 'Română', // Romania
  },
  {
    value: 'ru',
    label: 'Pусский', // Russia
  },
  {
    value: 'es',
    label: 'Español (España)', // Spanish Spain
  },
  {
    value: 'esl',
    label: 'Español (Latin America)', // Latin Spanish
  },
  {
    value: 'te',
    label: 'తెలుగ', // Telugu
  },
  {
    value: 'th',
    label: 'ภาษาไทย', // Thai
  },
  {
    value: 'tr',
    label: 'Türkçe', // Turkish
  },
  {
    value: 'vi',
    label: 'Tiếng việt', // Vietnamese
  },
];
export default languages;
